var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42871 1.75L4.66945 1.09921L5.42871 0.213409L6.18797 1.09921L5.42871 1.75ZM6.42871 14.875C6.42871 15.4273 5.981 15.875 5.42871 15.875C4.87643 15.875 4.42871 15.4273 4.42871 14.875L6.42871 14.875ZM0.919454 5.47421L4.66945 1.09921L6.18797 2.40079L2.43797 6.77579L0.919454 5.47421ZM6.18797 1.09921L9.93797 5.47421L8.41945 6.77579L4.66945 2.40079L6.18797 1.09921ZM6.42871 1.75L6.42871 14.875L4.42871 14.875L4.42871 1.75L6.42871 1.75Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.25L13.2407 19.9008L14 20.7866L14.7593 19.9008L14 19.25ZM15 6.125C15 5.57272 14.5523 5.125 14 5.125C13.4477 5.125 13 5.57271 13 6.125L15 6.125ZM9.49074 15.5258L13.2407 19.9008L14.7593 18.5992L11.0093 14.2242L9.49074 15.5258ZM14.7593 19.9008L18.5093 15.5258L16.9907 14.2242L13.2407 18.5992L14.7593 19.9008ZM15 19.25L15 6.125L13 6.125L13 19.25L15 19.25Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrow);
export default __webpack_public_path__ + "static/media/Sort_arrow.66700510fb32b336d5bc6e5fa764a13e.svg";
export { ForwardRef as ReactComponent };